import React from 'react';
import { Image, View } from 'react-native-web';
import { Android, kbd_success_icon } from '../../../../utils/DictionaryManagementUtils';
import {
  getImageByKey,
  img_scr_onboarding_03_a_and,
  img_scr_onboarding_03_a_ios,
} from '../../../../utils/ImagesManagementUtils';
import LargeTextWithSpecialFont from '../../AuxiliaryComponent/TextComponent/LargeTextWithSpecialFont';
import LargeBtnWithFilling from '../../AuxiliaryComponent/ButtonComponent/LargeBtnWithFilling';
import { getRef } from '../../../../utils/Utils';

//= ========================================================================
const SuccessSelectedWithOutKeyboardFP = ({
  globJSON,
  simPlatform,
  language,
  slideshowRefs,
}) => {
  const { colors } = globJSON.configurations.theme;
  const { instructions } = globJSON.configurations.onboarding;

  const img2 = getImageByKey(instructions.kbd_success_icon, kbd_success_icon);
  const myStyles = {
    kbd_success_icon: {
      alignSelf: 'center',
      marginTop: 58,
      width: 174,
      height: 174,
    },
    TitleStyle: {
      marginTop: 20,
      marginBottom: 10,
    },
    phoneImage: {
      width: 240,
      height: simPlatform === Android ? 427 : 520,
      position: 'absolute',
      backgroundColor: colors.app_background_color,
    },
  };

  return (
    <View ref={getRef(slideshowRefs)}>
      <Image
        fadeDuration={0}
        style={myStyles.phoneImage}
        source={simPlatform === Android ? img_scr_onboarding_03_a_and : img_scr_onboarding_03_a_ios}
      />
      <Image
        fadeDuration={0}
        resizeMode="contain"
        style={myStyles.kbd_success_icon}
        source={img2}
      />
      <View style={myStyles.TitleStyle}>
        <LargeTextWithSpecialFont
          globJSON={globJSON}
          simPlatform={simPlatform}
          language={language}
          txt={instructions.success}
        />
      </View>
      <LargeBtnWithFilling
        globJSON={globJSON}
        simPlatform={simPlatform}
        inputText={instructions.o_done}
      />
    </View>
  );
};

export default SuccessSelectedWithOutKeyboardFP;
